export default "__VITE_ASSET__DWAWTjEO__"